import React, { useState, useEffect } from "react";
import { ShoppingCart } from "lucide-react";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";

const CardProduct = ({ product, loading = false }) => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  const formatPrice = (value) => {
    const num = typeof value === "string" ? parseFloat(value) : Number(value);
    return isNaN(num)
      ? "0,00"
      : num.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
  };

  const calculatePromotionalPrice = () => {
    const price = product?.price || 0;
    const discount = product?.discount_percentage || 0;
    return price - (price * discount) / 100;
  };

  if (loading || !showContent) {
    return (
      <Box className="border border-gray-200 rounded-xl shadow overflow-hidden dark:bg-gray-800 w-80 m-4">
        <Box sx={{ position: "absolute", zIndex: 1 }}>
          <Skeleton width={90} height={50} sx={{ bgcolor: "grey.400" }} />
        </Box>
        <Box className="p-4">
          <Skeleton variant="rectangular" width="100%" height={200} />
        </Box>
        <Box className="px-4">
          <Skeleton width="60%" height={28} />
          <Skeleton width="80%" height={20} sx={{ mt: 1 }} />
          <Box sx={{ mt: 2, mb: 2 }}>
            <Skeleton width="40%" height={32} />
            <Skeleton width="30%" height={20} sx={{ mt: 1 }} />
          </Box>
          <Skeleton width="70%" height={20} sx={{ mb: 2 }} />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={44}
            sx={{ mb: 2 }}
          />
        </Box>
      </Box>
    );
  }

  const isPromocao = Boolean(product?.promotion_is_active);
  const precoPromocional = calculatePromotionalPrice();
  const precoFormatado = formatPrice(precoPromocional);
  const precoOriginalFormatado = formatPrice(product?.price);
  const precoParcelado = formatPrice(
    (precoPromocional || product?.price || 0) / 12
  );
  const main_image = `${process.env.REACT_APP_API_URL}/${product?.main_image_url}`;

  const createSlug = (name) => {
    return name
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .slice(0, 50);
  };

  const productSlug = createSlug(product?.name || "produto");
  const productUrl = `/produto/${product?.id}`;
  console.log(productUrl);
  console.log("Product ID:", product?.id);

  return (
    <Link
      to={productUrl}>
    <div className="border border-gray rounded-xl shadow-lg overflow-hidden transition-all hover:shadow-xl dark:bg-gray-800 w-80 md:m-4">
      {isPromocao && (
        <div className="absolute bg-red-600 text-white px-4 py-1 text-sm font-bold rounded-tl-lg">
          PROMOÇÃO
        </div>
      )}

      <div className="overflow-hidden p-9 relative">
        {isPromocao && (
          <div className="absolute top-2 right-2 bg-yellow-400 text-black px-2 py-1 rounded-full text-xs font-bold">
            -{product?.discount_percentage || 0}%
          </div>
        )}
        <img
          src={main_image}
          alt={product?.name || "Produto"}
          className="w-full h-[200px] object-contain transition-transform duration-500 hover:scale-105"
        />
      </div>

      <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 px-4 mt-0 mb-2 line-clamp-1">
        {product?.name || "Nome do Produto"}
      </h3>

      <p className="text-sm text-gray-600 dark:text-gray-300 px-4 mb-0 line-clamp-2">
        {product?.description || "Descrição do produto"}
      </p>

      <div className="px-4 py-4">
        <div className="flex items-center gap-2 mb-2">
          <p
            className={`text-2xl font-bold ${
              isPromocao ? "text-red-600" : "text-green-600"
            }`}>
            R$ {precoFormatado}
          </p>
          {isPromocao && (
            <p className="text-sm text-gray-500 line-through">
              R$ {precoOriginalFormatado}
            </p>
          )}
        </div>

        <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
          ou 12x de R$ {precoParcelado} com juros
        </p>

        <Link
          to={productUrl}
          state={{ productId: product.id }} // Passa o ID via state
          className="flex justify-center gap-2 bg-green-600 text-white px-6 py-3 rounded-lg font-semibold transition-all hover:bg-green-700 hover:scale-105 mb-0">
          <ShoppingCart className="icon" />
          Comprar <i className="fas fa-cart-plus ml-2"></i>
        </Link>
      </div>
    </div>
    </Link>
  );
};

export default CardProduct;
